<template>
    <v-app>
        <v-container fluid fill-height class="ma-0 pa-0">
            <v-row class="fill-height" >
                <!-- Don't display side image on screens less than 960px -->
                <v-col class="pa-0 d-none d-md-block">
                    <div class="side-image d-flex align-end">
                        <span class="footer">{{$t('PAGE_TAGLINE')}} | <a :href="policyUrl" target="_blank">{{ $t('PAGE_TERMS_AND_POLICY') }}</a></span>
                    </div>
                </v-col>
                <v-col class="pa-0 d-flex flex-column justify-space-between align-center special-small-padding">
                    <div class="my-auto special-small-width" style="max-width: 70%">
                        <router-view :key="$route.fullPath"></router-view>
                    </div>
                    <span class="footer full-footer d-md-none">{{$t('PAGE_TAGLINE')}} | <a :href="policyUrl" target="_blank">{{ $t('PAGE_TERMS_AND_POLICY') }}</a></span>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script lang="ts">
import Config from "@/config";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Page extends Vue {
    get policyUrl()
    {
        return Config.TERMS_AND_POLICIES_URL;
    }
}
</script>

<style scoped>
/deep/ h1 {
    color: #3c4886;
}

.side-image {
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 100%;
}

@media (max-height: 360px) {
    .side-image {
        background-image: url(../assets/side-image-360.webp);
    }
}

@media (min-height: 361px) and (max-height: 720px) {
    .side-image {
        background-image: url(../assets/side-image-720.webp);
    }
}

@media (min-height: 721px) and (max-height: 1080px) {
    .side-image {
        background-image: url(../assets/side-image-1080.webp);
    }
}

@media (min-height: 1081px) and (max-height: 1440px) {
    .side-image {
        background-image: url(../assets/side-image-2k.webp);
    }
}

@media (min-height: 1441px) {
    .side-image {
        background-image: url(../assets/side-image-4k.webp);
    }
}

@media (max-width: 360px) {
    .special-small-padding {
        margin-left: 11px;
    }
}

@media (max-width: 460px) {
    .special-small-width {
        max-width: 99% !important;
    }
}

.footer {
    text-align: center;
    padding: 10px 0;
    width: 100%;
}

.side-image .footer {
    color: white;
    background: rgba(35, 72, 124, .8);
    
}
.side-image .footer a {
    color: inherit;
}
</style>
